import React from 'react'
import { Box } from '@mui/material'
import {
  AutoAwesome as AssistantIcon,
  SupportAgent as SupportIcon,
  MenuBook as DocsIcon,
  History as ActivityIcon,
} from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import {
  SegmentedPills,
  SegmentedPillItem,
} from '@hapana/shared/web/components/shared/segmented-pills/segmented-pills.component'
import { SupportAssistantTab } from '../support-assistant.types'
import { useSupportAssistant } from '../support-assistant.hooks'

const ICON_SX = { fontSize: '0.875rem' }

export function TabNavigation() {
  const { activeTab, setActiveTab } = useSupportAssistant()
  const { t } = useTranslation('core')

  const tabs: SegmentedPillItem<SupportAssistantTab>[] = [
    {
      key: 'chats',
      label: t('supportAssistant.tabs.chats', 'Chats'),
      icon: <AssistantIcon sx={ICON_SX} />,
    },
    {
      key: 'support',
      label: t('supportAssistant.tabs.support'),
      icon: <SupportIcon sx={ICON_SX} />,
    },
    {
      key: 'docs',
      label: t('supportAssistant.tabs.docs'),
      icon: <DocsIcon sx={ICON_SX} />,
    },
    {
      key: 'activity',
      label: t('supportAssistant.tabs.activity'),
      icon: <ActivityIcon sx={ICON_SX} />,
    },
  ]

  return (
    <Box sx={{ px: 1.5, py: 1, bgcolor: 'white' }}>
      <SegmentedPills items={tabs} value={activeTab} onChange={setActiveTab} />
    </Box>
  )
}
